import React, { useState, useCallback } from 'react';
import toast from 'react-hot-toast';
import { useProfileStore } from '../../stores/useDataStore';
import VideoUploader from '../common/VideoUploader'; // 🟢 1. Importamos el orquestador de videos
import { uploadVideo } from '../../api/media'; // 🟢 2. Importamos la función de subida de videos

const UploadClipModal = ({ isOpen, onClose, username }) => {
  const addClip = useProfileStore((state) => state.addClip);
  const [clipUrl, setClipUrl] = useState(null);
  const [title, setTitle] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  // 🟢 3. El VideoUploader actualiza nuestro estado local
  const handleUploadChange = useCallback((url) => {
    setClipUrl(url);
  }, []);

  const handleUpload = () => {
    if (!clipUrl) {
      toast.error('Por favor, selecciona un video para subir.');
      return;
    }
    setIsSubmitting(true);
    // 🟢 4. Llamamos a la acción del store con el payload JSON correcto
    addClip({ clipUrl, title })
      .finally(() => {
        setIsSubmitting(false);
        handleClose();
      });
  };

  const handleClose = () => {
    if (isSubmitting) return;
    setClipUrl(null);
    setTitle('');
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div
      className="fixed inset-0 bg-black bg-opacity-75 z-50 flex items-center justify-center"
      onClick={handleClose}
    >
      <div
        className="bg-white dark:bg-gray-800 rounded-lg shadow-xl max-w-lg w-full p-6"
        onClick={(e) => e.stopPropagation()}
      >
        <h2 className="text-xl font-bold text-gray-800 mb-4">
          Subir Nuevo Clip
        </h2>

        <div
          className="space-y-4"
        >
          {/* 🟢 5. Reemplazamos la lógica de dropzone por nuestro orquestador */}
          <VideoUploader
            label="Archivo de video"
            uploader={uploadVideo}
            onChange={handleUploadChange}
            initialVideoUrl={clipUrl}
          />
          <div>
            <label
              htmlFor="clipTitle"
              className="block text-sm font-medium text-gray-700 dark:text-gray-300"
            >
              Título del Clip
            </label>
            <input
              type="text"
              id="clipTitle"
              value={title}
              onChange={(e) => setTitle(e.target.value)}
              className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600"
            />
          </div>
        </div>

        <div className="flex justify-end space-x-2 mt-6">
          <button
            onClick={handleClose}
            className="py-2 px-4 bg-gray-200 text-gray-800 font-semibold rounded-md hover:bg-gray-300 dark:bg-gray-600 dark:text-gray-200 dark:hover:bg-gray-500"
          >
            Cancelar
          </button>
          <button
            onClick={handleUpload}
            className="py-2 px-4 bg-blue-600 text-white font-semibold rounded-md hover:bg-blue-700 disabled:bg-blue-300"
            disabled={!clipUrl || isSubmitting}
          >
            {isSubmitting ? 'Subiendo...' : 'Subir Clip'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default UploadClipModal;
